import type { BookingDoc, FlightApprovalDoc } from './types';

export type ApprovalState = 'approved' | 'stale' | 'missing';

/**
 * Whether a student booking is cleared to fly. An approval only counts while the
 * booking still has the exact times the CFI approved — a reschedule makes it stale.
 */
export function approvalState(
  booking: Pick<BookingDoc, 'startDateTime' | 'endDateTime'>,
  approval: FlightApprovalDoc | null | undefined,
): ApprovalState {
  if (!approval) return 'missing';
  const same =
    approval.approvedStart?.toMillis?.() === booking.startDateTime.toMillis() &&
    approval.approvedEnd?.toMillis?.() === booking.endDateTime.toMillis();
  return same ? 'approved' : 'stale';
}
